<template lang="pug">
  .coach-detail-reviews
    swiper(:options="swiperOption")
      swiper-slide(v-for="review in reviews" :key="review.id")
        .reviewer {{ reviewerName(review.monthOfReview) }}
        rating-star(:rating="review.coachRateAverage")
        .comment(v-if="review.comment") {{ review.comment }}
        f7-link(
          href="#"
          class="review-link"
          @click="$emit('click', review.id)")
          | もっと見る
</template>

<style lang="scss" scoped>
.coach-detail-reviews {
  .swiper-slide {
    display: flex;
    flex-direction: column;
    @extend %body-text;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    height: 215px;
    width: 90%;
    margin: auto;

    .reviewer,
    .comment {
      padding: 0 18px;
    }
    .rating-star {
      padding-left: 16px;
    }
    .comment {
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 5;
      line-height: 21px;
    }
    .reviewer {
      padding-top: 16px;
    }
    .review-link {
      margin-top: auto;
      margin-bottom: 16px;
      color: $color-primary;
    }
  }
  .swiper-slide:first-child {
    margin-left: 16px;
  }
}
</style>

<script>
import RatingStar from '@/components/atoms/RatingStar'
import Formatter from '@/components/mixins/Formatter'

export default {
  components: {
    RatingStar,
  },
  mixins: [Formatter],
  props: {
    reviews: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 4,
      },
    }
  },
  methods: {
    reviewerName(monthOfReview) {
      return `${this.dateFormat(monthOfReview, 'Y年M月')}受講生`
    },
  },
}
</script>
